const ValidationError = require('./errors/ValidationError');
const ErrorMessageCompiler = require('./ErrorMessageCompiler');
const MoneyService = require('./MoneyService');

class AccountLimitsValidationService {
  #value;
  #maxValue;
  #errorMessages = {};

  constructor(args = {}, errorMessages = {}) {
    this.#value = args.value || 0;
    this.#maxValue = args.maxValue || 0;
    this.#errorMessages = errorMessages;
  }

  validate() {
    try {
      this.validateMinValue();
      this.validateMaxValue();
    } catch (error) {
      throw new ValidationError(error.message, error.field, null, error.code, error.data);
    }
  }

  validateMinValue() {
    if (!this.#errorMessages.MIN_VALUE) {
      throw new ReferenceError('MIN_VALUE is not defined');
    }

    if (!this.#value || this.#value < 0) {
      throw this.#errorMessages.MIN_VALUE;
    }
  }

  validateMaxValue() {
    if (!this.#errorMessages.MAX_VALUE) {
      throw new ReferenceError('MAX_VALUE is not defined');
    }

    if (this.#value > this.#maxValue) {
      const error = this.#errorMessages.MAX_VALUE;
      const dataToCompile = {
        maxValue: MoneyService.formatToBR(this.#maxValue, false)
      };
      throw new ErrorMessageCompiler(error, dataToCompile).compile();
    }
  }
}

module.exports = AccountLimitsValidationService;
